import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import homeReducer from './reducers/homeReducer';
import authReducer from './reducers/authReducer';
import cardReducer from './reducers/cardReducer';
import orderReducer from './reducers/orderReducer';
import dashboardReducer from './reducers/dashboardReducer';
import chatReducer from './reducers/chatReducer';

// Configuration for redux-persist
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['home'] // Only persisting the home reducer
};

const homePersistConfig = {
    key: 'home',
    storage,
    whitelist: ['categorys', 'products', 'totalProduct', 'latest_product', 'topRated_product', 'discount_product', 'relatedProducts', 'moreProducts', 'items'] // Only persisting categorys and products
};

const rootReducer = combineReducers({
    home: persistReducer(homePersistConfig, homeReducer),
    auth: authReducer,
    card: cardReducer,
    order: orderReducer,
    dashboard: dashboardReducer,
    chat: chatReducer
});

export default persistReducer(persistConfig, rootReducer);
